import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllAssociation = lazy(() => import("../pages/association"));

export const AssociationRouter = [
  {
    path: "/master-management/association",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllAssociation />
          </Suspense>
        ),
      },
    ],
  },
];
